import tokens from './tokens';

const PIXELS_IN_ONE_REM = tokens?.fontSize ?? 16;

export default {
  spacing: (...params: number[]) => params.map(space => `${space * 0.25}rem`).join(' '),
  /**
   * Converts pixels to rem
   * @example pxToRem(16) => '1rem'
   */
  pxToRem: (px: number) => `${px / PIXELS_IN_ONE_REM}rem`
};
